import { useAuthenticated } from '~/src/common/hooks/user/useAuthenticated';
import { useFeatureFlag } from '~/src/common/services/FeatureFlag';
import I18n from '~/src/common/services/I18n';
import { TP_WIDGETS } from '~/src/common/services/Trustpilot/utils';

import { Placeholder, HEIGHT, Title } from './layout';

export const HomeTrustpilot = () => {
  const isAuthenticated = useAuthenticated();
  const isTrustpilotEnabled = useFeatureFlag('widgets-trustpilot');
  const shouldDisplayWidget = isTrustpilotEnabled && !isAuthenticated;

  return shouldDisplayWidget ? (
    <div>
      <Title>{I18n.t('home.trustpilot.title')}</Title>
      <div
        className="trustpilot-widget"
        data-locale="fr-FR"
        data-template-id={TP_WIDGETS.companySlider}
        data-businessunit-id={process.env.NEXT_PUBLIC_TRUSTPILOT_BUSINESSUNIT_ID}
        data-stars="4,5"
        data-review-languages="fr"
        data-font-family="Rubik"
        data-style-width="100%"
        data-style-height={`${HEIGHT}px`}>
        <Placeholder>
          <a href="https://fr.trustpilot.com/review/mon-marche.fr" target="_blank" rel="noreferrer">
            <span>Trustpilot</span>
            <strong>★★★★☆ </strong>
          </a>
        </Placeholder>
      </div>
    </div>
  ) : null;
};
